import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Text,
} from '@chakra-ui/react';

export const ChakraAccordion = ({ accordionData }) => {
  return (
    <Accordion allowToggle defaultIndex={[0]} zIndex={1000}>
      {accordionData.map(({ summary, details }, index) => (
        <AccordionItem key={index}>
          <AccordionButton _expanded={{ bg: '#273746', color: 'white' }}>
            <Box flex="1" textAlign="left" alignItems={'flex-start'}>
              <Text fontSize={'3xl'}>{summary}</Text>
            </Box>
            <AccordionIcon width={30} height={30} />
          </AccordionButton>

          <AccordionPanel py={6} mb={4}>
            <Text fontSize={'lg'}>{details}</Text>
          </AccordionPanel>
        </AccordionItem>
      ))}
    </Accordion>
  );
};
